import { Empresa } from ".";

export class Grupo{

    id: number = 0;
    empresaId: number = 0;
    empresa!: Empresa;
    nome: string = "";
    situacao: string = "";

    constructor(model?: Grupo){

        if(!model)
            return;

        this.id = model.id;
        this.empresaId = model.empresaId;
        this.empresa = model.empresa;
        this.nome = model.nome;
        this.situacao = model.situacao;        
    }
}